// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"504":"afaf4cd3","787":"0f269576","790":"354b7be4","929":"7ed55df2"}[chunkId] + ".chunk.js";
};